<template>
  <div>
  <Header
    :productRequestAlert = "productRequestAlert"
  ></Header>
    <NeedCategories></NeedCategories>
  <div class="g-product-list">
    <v-container grid-list-md text-xs-center v-if="product && product.displayDetails" class="current-prod-detail-sect">
      <div class="go-back-btn-sect">
        <v-btn
          slot="activator"
          color="transparent"
          class="go-back-btn"
          :ripple="false"
          to="/needs"
        >
          <v-icon>icon-arrow-347</v-icon>
          <span>{{$t('products.back_to_needs')}}</span>
        </v-btn>
      </div>
      <v-layout row wrap>
        <v-flex sm6 md6 lg6 class="img-slider-sect">
          <image-carousel
            :images="product.options && product.options.images"
            :generalImage="product.image"
            :product="product"
            :key="renderingImageCarousel"
          />
        </v-flex>
        <v-flex sm6 md6 lg6 class="product-info-section">
          <v-layout column wrap class="ex-item">
            <div class="d-flex justify-space-between align-center product-name-sect">
              <div class="text-md-left">
                <v-card-text v-if="product.displayDetails">
                  <h1 class="px-0 ex-item-name">
                    {{product.displayDetails.name}}</h1>
                </v-card-text>
              </div>
            </div>

            <div class="text-md-left prod-info">
              <v-flex class="d-flex info-sect">
                <v-flex v-if="product.displayDetails && product.displayDetails.location" class="location-card-sect">
                  <v-card-text class="ex-item-location">
                    <v-icon class="m-r-12">icon-location</v-icon>
                    <span class="location-text">{{ product.displayDetails.location }}</span>
                  </v-card-text>
                </v-flex>
                <v-flex class="categories-card-sect d-flex">
                  <v-icon class="f-s-13 m-r-12">icon-goods</v-icon>
                  <v-breadcrumbs :items="breadcrumb" divider="/">
                    <template slot="item" slot-scope="props">
                      {{ props.item.text }}
                    </template>
                  </v-breadcrumbs>
                </v-flex>
              </v-flex>
            </div>
            <v-flex  id="geeks">
              <p class="ex1"
                           v-if="product.displayDetails"
              >{{product.displayDetails.description}}</p>
            </v-flex>
            <v-flex
              class="text-md-left prod-request-btn-sect">
              <v-btn
                class="donation-btn"
                @click.native="openRequestModal"
                :ripple="false"
              >
                {{ $t('headers.donation')}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout>
      </v-layout>
      <v-dialog v-model="dialog" max-width="550px">
        <v-form ref="form" v-model="valid" lazy-validation class="disable-form-contact">
          <v-card color="grey lighten-4">
            <v-card-title class="cancel-btn-card-sect">
              <v-btn class="cancel-request-btn1" :ripple="false" @click.native="closeModal">
                <v-icon>icon-cancel</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-title class="text-md-center card-first-sect">
              <span class="modal-message">{{$t('products.donation_message')}}</span>
              <h2>{{product.phoneNumber}}</h2>
            </v-card-title>
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>
  </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import ImageCarousel from './imageCarousel'
import { EventBus } from '../../event-bus'
import { createLocation, validateEmail } from '../../helpers/main'
import Header from '../../components/global/Header.vue'
import NeedCategories from '../../components/categories/needCategories'

export default {
  name: 'Need',
  components: {
    Header,
    ImageCarousel,
    NeedCategories
  },
  data: () => ({
    productRequestAlert: false,
    userData: {},
    renderingImageCarousel: false,
    requestMessage: '',
    valid: true,
    dialog: false,
    requestDisabled: false,
    items: [],
    ROOT_API: process.env.ROOT_API,
    product: [],
    breadcrumb: [],
    dialogConfirm: false,
    needId: null,
    validConfirm: true,
    isDisabled: false,
    disabledTimeout: 500,
    requestedOption: {
      requested: false,
      isGiven: null,
      options: {},
      contactBy: ''
    }
  }),
  computed: {
    ...mapState({
      loggedUser: state => state.auth.userData
    }),
    phoneNumberRules () {
      return [
        v => !!v || this.$t('pnone_required'),
        v => (!v || /^\+?(?:[0-9] ?){6,14}[0-9]$/.test(v)) || this.$t('phone_not_valid')
      ]
    },
    contactByEmailRules () {
      const rules = []
      if (this.enabledEmail) {
        rules.push(v => !!v || this.$t('email_required'))
        rules.push(v => validateEmail(v) || this.$t('email_not_valid'))
      }
      return rules
    }
  },
  watch: {
    loggedUser (val) {
      if (this.product && this.product.id) {
        setTimeout(() => {
          this.getProduct(this.product.id)
        }, 0)
      }
    },
    $route (val) {
      // for ForceUpdating Image Carousel Component
      this.renderingImageCarousel = !this.renderingImageCarousel
      if (val.params && val.params.needId) {
        this.getProduct(val.params.needId)
      }
      // this.$store.dispatch('products/setDefaultMetas').then((res) => {}).catch(console.error)
    },
    dialogConfirm (val) {
      val || this.close()
      this.$refs.formConfirm.resetValidation()
    }
  },
  mounted () {
    const parseIntProductId = this.$route.params.needId
    if (parseIntProductId) {
      this.getProduct(parseIntProductId)
    } else {
      this.$router.push('/products')
    }
  },
  methods: {
    getProduct (needId) {
      if (localStorage.getItem('token')) {
        this.$store.dispatch('products/getProductWithRequests', needId).then((res) => {
          this.getProductResponse(res)
        })
      } else {
        this.$store.dispatch('products/getProduct', needId).then((res) => {
          this.getProductResponse(res)
        }).catch(console.error)
      }
      let data = {
        cat: null,
        filter: []
      }
      this.$store.dispatch('categories/setMainSearchData', data)
    },
    languageChanged () {
      this.getProductList(this.product, this.breadcrumb)
    },
    getProductResponse (res) {
      this.requestedOption = Object.assign(this.requestedOption, res.requestOption)
      this.getProductList(res.product, res.breadcrumb)
      // Disable or Enable request button
      if (this.loggedUser.id && this.product.userId === this.loggedUser.id) {
        this.requestDisabled = true
      }
    },
    getProductList (product, breadcrumbs) {
      if (breadcrumbs) {
        breadcrumbs.forEach(breadcrumb => {
          breadcrumb.CategoryTranslations.forEach(CategoryTranslation => {
            if (CategoryTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
              breadcrumb.text = CategoryTranslation.name
            } else if (!breadcrumb.text) {
              breadcrumb.text = CategoryTranslation.name
            }
          })
        })
        this.breadcrumb = breadcrumbs
      }
      if (product) {
        product.displayDetails = {}
        product.ProductTranslations.forEach(productTranslation => {
          if (productTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
            product.displayDetails.name = productTranslation.name
            product.displayDetails.description = productTranslation.description
          } else if (!product.displayDetails.name) {
            product.displayDetails.name = productTranslation.name
            product.displayDetails.description = productTranslation.description
          }
        })
        product.ProductAddresses.forEach(productAddress => {
          let addressData = productAddress.Address
          if (productAddress.languageId === this.$store.getters['common/getActiveLanguage'].id) {
            product.displayDetails.location = createLocation(addressData)
          } else if (!product.displayDetails.location) {
            product.displayDetails.location = createLocation(addressData)
          }
        })
        this.product = product
      }
    },
    closeModal () {
      this.dialog = false
    },
    openRequestModal () {
      this.dialog = true
      this.$emit('openLogModal')
      let productId = {
        id: this.product.id
      }
      this.$store.dispatch('products/saveDonateCount', productId).then((res) => {
        if (res) {
          this.closeModal()
          this.$toastr(res.type, res.message, this.$t(res.type))
        }
      }).catch(console.error)
    },
    close () {
      this.dialogConfirm = false
      setTimeout(() => {
        this.needId = null
      }, 300)
    }
  },
  created () {
    EventBus.$on('language-changed', this.languageChanged)
  },
  beforeMount () {
    this.userData = JSON.parse(JSON.stringify(this.loggedUser))
  }
}
</script>

<style lang="scss" scoped>
p.ex1 {
  max-width: 150px!important;
}
@import "../../assets/sass/desktop/products.scss";
@import "../../assets/sass/desktop/notificationPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/products/Need.vue